const MobileFilter = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g fill="none" fillRule="evenodd">
        <g fill="currentColor" fillRule="nonzero">
          <g>
            <path
              d="M1 0C.448 0 0 .448 0 1s.448 1 1 1h16c.552 0 1-.448 1-1s-.448-1-1-1H1zm1 4l5 6v7c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-7l5-6H2z"
              transform="translate(-71 -315) translate(71 315)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export { MobileFilter };
